upstack.controller('WebinarCtrl', ['$http', function($http){
    var vm = this;
    vm.payload = {
        first_name: '',
        last_name: '',
        email: '',
        phone_number: ''
    };
    vm.initPayload = angular.copy(vm.payload);
    vm.success = false;
    
    vm.submitWebinarForm = function(e) {
        e.preventDefault();
        
        $http.post('https://api.upstack.co/v1/webinar', vm.payload).then(function(response){
            console.log(response);
            if(response.data.code === 200) {
                vm.payload = angular.copy(vm.initPayload);
                vm.success = true;
            }
        }, function(error) {
            console.log('error', error);
        });
    }
}]);
